<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">SGK Şubesi</label>
            <v-validator :errors="errors" parameter="BranchId" :watch="sgkBranch">
                <v-select-list :options="sgkBranches" label="Name" v-model="sgkBranch" placeholder="SGK Şube"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">SGK Meslek Kodu</label>
            <v-validator :errors="errors" parameter="personeller[0].meslekkodu" :watch="jobCode">
                <v-select-list v-model="jobCode" :options="jobCodes" label="Combine" v-on:search="searchOT" placeholder="SGK Meslek Kodu" :loading="loadingOT"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Tebliğ Tarihi</label>
            <v-validator :errors="errors" parameter="personeller[0].NotifyDate" :watch="value.NotifyDate">
                <v-date-picker v-model="value.NotifyDate" placeholder="Tebliğ Tarihi"></v-date-picker>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">İşe Giriş Tarihi</label>
            <v-validator :errors="errors" parameter="personeller[0].iseGirisTarihi" :watch="value.iseGirisTarihi">
                <v-date-picker v-model="value.iseGirisTarihi" placeholder="İşe Giriş Tarihi"></v-date-picker>
            </v-validator>
        </div>
    </div>
</template>

<script>
import CompanyApi from '@/api/company'
import SystemDataApi from '@/api/system-data'

export default{
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return {
            sgkBranches:[],
            jobCodes:[],
            loadingOT:false
        }
    },
    mounted(){
        this.getBranches()
    },
    methods:{
        getBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
        searchOT(search){
            if(search){
                this.loadingOT = true
                SystemDataApi.OccupationTitlePrefix(search)
                .then(res=>{
                    this.jobCodes = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.SGKOccupationCode,d.Name].join(' - ')
                    }))
                    this.loadingOT = false
                }).catch(err=>{ 
                    this.loadingOT = false 
                })
            }
        },
    },
    computed:{
        sgkBranch:{
            get:function(){
                return this.sgkBranches.find(b=>b.Id==this.value.branchId)
            },
            set:function(value){
                this.value.branchId = value?.Id || null
            }
        },
        jobCode:{
            get:function(){
                return this.jobCodes.find(i=>i.Id==this.value.OccupationTitleId)
            },
            set:function(value){
                this.value.OccupationTitleId = value?.Id || null
                this.value.meslekkodu = value?.SGKOccupationCode || null
            }
        },
    }
}
</script>